import React, { Suspense } from 'react';
import TrackingProvider from '@jobmatchme/tracking/es/provider/Tracking';
import RouteProvider, { Route } from '@jobmatchme/routing/es/provider/External';
import getConfig from '@jobmatchme/profile-components/es/resources/getConfig';
import PageLoader from '@jobmatchme/ui/es/components/styleguide/JmmLoader';
import CloseIcon from '@jobmatchme/ui/es/components/icons/Close/index';
import { getUrlLocale } from '@jobmatchme/utils/es/getUrlParam';
import { lazyLoader } from '@jobmatchme/library-utils/es/lazy';
import IconButton from '@material-ui/core/IconButton';
import packageVersions from '../packageVersions.json';
import { SnackbarProvider } from 'notistack';
import AuthProvider from '@jobmatchme/react-auth/es/Provider';

//import {useAbTest} from '@jobmatchme/utils/es/ABTest'
//import {FUNNEL_ABTEST_NAME} from '@jobmatchme/utils/es/funnelAbTest'
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var FunnelLogistics = lazyLoader(function () {
  return import( /* webpackChunkName: 'funnelLogistics' */'./FunnelLogistics');
});
var FunnelAll = lazyLoader(function () {
  return import( /* webpackChunkName: 'funnelAll' */'./FunnelAll');
});
var FunnelGeneric = lazyLoader(function () {
  return import( /* webpackChunkName: 'funnelGeneric' */'./FunnelGeneric');
});
var RegistrationDefined = lazyLoader(function () {
  return import( /* webpackChunkName: 'registrationDefined' */'./RegistrationDefined');
});
var RegistrationInverse = lazyLoader(function () {
  return import( /* webpackChunkName: 'registrationInverse' */'./RegistrationInverse');
});
var NotFoundPage = lazyLoader(function () {
  return import( /* webpackChunkName: 'notFoundPage' */'@jobmatchme/landing-page-components/es/components/truck/common/NotFoundPage');
});
var MatchesApp = lazyLoader(function () {
  return import( /* webpackChunkName: 'matchesApp' */'@jobmatchme/pc-matching/es/components/App');
});
var PageOptIn = lazyLoader(function () {
  return import( /* webpackChunkName: 'optIn' */'@jobmatchme/pc-matching/es/components/Pages/OptIn');
});
var PageVerify = lazyLoader(function () {
  return import( /* webpackChunkName: 'optIn' */'@jobmatchme/pc-matching/es/components/Pages/Verify');
});
var PageLogin = lazyLoader(function () {
  return import( /* webpackChunkName: 'pageLogin' */'@jobmatchme/pc-matching/es/components/Pages/Login');
});
var OptoutSettings = lazyLoader(function () {
  return import( /* webpackChunkName: 'optoutSettings' */'@jobmatchme/pc-matching/es/components/OptoutSettings');
});
var Dashboard = lazyLoader(function () {
  return import( /* webpackChunkName: 'dashboardApp' */'@jobmatchme/bc-dashboard/es/components/App');
});
var RoutedApp = function RoutedApp(_ref) {
  var router = _ref.router,
    location = _ref.location;
  // activate ABTest
  // useAbTest(FUNNEL_ABTEST_NAME)

  var pcFunnelRoute = function pcFunnelRoute(discriminator) {
    var vertical = getConfig(discriminator)('pc').vertical;
    return /*#__PURE__*/_jsx(Route, {
      exact: true,
      id: 'pcfunnel' + discriminator,
      path: {
        de: '/jobs/' + vertical.de + '/suche/*',
        at: '/jobs/' + vertical.at + '/suche/*',
        pl: '/jobs/' + vertical.pl + '/szukaj-pracy/*',
        en: '/employee/' + vertical.en + '/jobsearch/*'
      },
      element: /*#__PURE__*/_jsx(FunnelGeneric, {
        discriminator: discriminator
      })
    });
  };
  var pcSimplifiedRegFormRoute = function pcSimplifiedRegFormRoute(discriminator) {
    var vertical = getConfig(discriminator)('pc').vertical;
    return /*#__PURE__*/_jsx(Route, {
      exact: true,
      id: 'pcSimplifiedRegFormRoute' + discriminator,
      path: {
        de: '/jobs/' + vertical.de + '/bewerben/*',
        at: '/jobs/' + vertical.at + '/bewerben/*',
        pl: '/jobs/' + vertical.pl + '/zastosowac/*',
        en: '/employee/' + vertical.en + '/application/*'
      },
      element: /*#__PURE__*/_jsx(RegistrationInverse, {
        discriminator: discriminator
      })
    });
  };
  var pcRegistrationRoute = function pcRegistrationRoute(discriminator) {
    var vertical = getConfig(discriminator)('pc').vertical;
    return /*#__PURE__*/_jsx(Route, {
      exact: true,
      id: 'pcreg' + discriminator,
      path: {
        de: '/jobs/' + vertical.de + '/suche/registrierung/*',
        at: '/jobs/' + vertical.at + '/suche/registrierung/*',
        pl: '/jobs/' + vertical.pl + '/szukaj-pracy/rejestracja/*',
        en: '/jobs/' + vertical.en + '/jobsearch/registration/*'
      },
      element: /*#__PURE__*/_jsx(RegistrationDefined, {
        discriminator: discriminator,
        variant: 'pc'
      })
    });
  };
  return /*#__PURE__*/_jsx(React.Suspense, {
    fallback: /*#__PURE__*/_jsx(PageLoader, {
      fullPage: true
    }),
    children: /*#__PURE__*/_jsxs(RouteProvider, {
      no404: true,
      locale: getUrlLocale(typeof window !== 'undefined' ? window.location.pathname : location),
      notFoundPage: NotFoundPage,
      packageVersions: packageVersions,
      router: router,
      location: location,
      children: [pcFunnelRoute('care'), pcFunnelRoute('truck'), pcFunnelRoute('logistics-scheduler'), pcFunnelRoute('service-gastro'), pcRegistrationRoute('care'), pcRegistrationRoute('truck'), pcRegistrationRoute('logistics-scheduler'), pcRegistrationRoute('service-gastro'), pcSimplifiedRegFormRoute('care'), pcSimplifiedRegFormRoute('truck'), pcSimplifiedRegFormRoute('logistics-scheduler'), pcSimplifiedRegFormRoute('service-gastro'), /*#__PURE__*/_jsx(Route, {
        exact: true,
        id: "pcfunnelLogistics",
        path: {
          de: '/jobs/logistik/suche/*',
          pl: '/jobs/logistyka/szukaj-pracy/*',
          at: '/jobs/logistik/suche/*',
          en: '/jobs/logistics/search/*'
        },
        element: /*#__PURE__*/_jsx(FunnelLogistics, {})
      }), /*#__PURE__*/_jsx(Route, {
        exact: true,
        id: "pcfunnelAll",
        path: {
          de: '/jobs/all/suche/*',
          pl: '/jobs/all/szukaj-pracy/*',
          at: '/jobs/all/suche/*',
          en: '/jobs/all/search/*'
        },
        element: /*#__PURE__*/_jsx(FunnelAll, {})
      }), /*#__PURE__*/_jsx(Route, {
        exact: true,
        id: 'pcLogin',
        path: {
          de: '/login/',
          pl: '/login/',
          at: '/login/',
          en: '/login/'
        },
        element: /*#__PURE__*/_jsx(PageLogin, {})
      }), /*#__PURE__*/_jsx(Route, {
        id: "pcoptin",
        path: {
          de: '/verify/:code/',
          pl: '/verify/:code/',
          at: '/verify/:code/'
        },
        element: /*#__PURE__*/_jsx(PageOptIn, {})
      }), /*#__PURE__*/_jsx(Route, {
        id: "pcoptout",
        path: {
          de: '/optout/',
          pl: '/optout/',
          at: '/optout/'
        },
        element: /*#__PURE__*/_jsx(PageOptIn, {})
      }), /*#__PURE__*/_jsx(Route, {
        id: "verify",
        path: {
          de: '/verify/',
          pl: '/verify/',
          at: '/verify/'
        },
        element: /*#__PURE__*/_jsx(PageVerify, {})
      }), /*#__PURE__*/_jsx(Route, {
        id: "pcOptoutSettings",
        path: {
          de: '/arbeitnehmer/app/optoutSettings/:token/',
          pl: '/pracownik/app/optoutSettings/:token/',
          at: '/arbeitnehmer/app/optoutSettings/:token/'
        },
        children: function children(_ref2) {
          var _ref2$match = _ref2.match;
          _ref2$match = _ref2$match === void 0 ? {} : _ref2$match;
          var _ref2$match$params = _ref2$match.params;
          _ref2$match$params = _ref2$match$params === void 0 ? {} : _ref2$match$params;
          var _ref2$match$params$to = _ref2$match$params.token,
            token = _ref2$match$params$to === void 0 ? undefined : _ref2$match$params$to;
          return /*#__PURE__*/_jsx(PageOptIn, {
            token: token
          });
        }
      }), /*#__PURE__*/_jsx(Route, {
        id: "pcOptoutSettingsNoToken",
        path: {
          de: '/arbeitnehmer/app/optoutSettings/',
          pl: '/pracownik/app/optoutSettings/',
          at: '/arbeitnehmer/app/optoutSettings/'
        },
        element: /*#__PURE__*/_jsx(OptoutSettings, {
          token: "logedin"
        })
      }), /*#__PURE__*/_jsx(Route, {
        id: 'pcmatching',
        path: {
          de: '/arbeitnehmer/app/*',
          pl: '/pracownik/app/*',
          at: '/arbeitnehmer/app/*',
          en: '/employee/app/*'
        },
        element: /*#__PURE__*/_jsx(MatchesApp, {})
      }), /*#__PURE__*/_jsx(Route, {
        id: "dashboard",
        path: {
          de: '/arbeitgeber/app/*',
          pl: '/pracodawca/app/*',
          at: '/arbeitgeber/app/*'
        },
        element: /*#__PURE__*/_jsx(Dashboard, {})
      }), /*#__PURE__*/_jsx(Route, {
        id: "bcPage",
        path: {
          de: '/arbeitgeber/',
          pl: '/pracodawca/',
          at: '/arbeitgeber/'
        }
      }), /*#__PURE__*/_jsx(Route, {
        staticPath: true,
        id: 'home',
        host: "https://jobmatch.me",
        path: {
          de: '/',
          pl: '/',
          at: '/',
          en: '/'
        }
      }), /*#__PURE__*/_jsx(Route, {
        id: 'lpImprint',
        path: {
          de: '/impressum/',
          pl: '/odcisk/',
          at: '/impressum/',
          en: '/imprint/'
        }
      }), /*#__PURE__*/_jsx(Route, {
        id: 'lpTerms',
        path: {
          de: '/nutzungsbedingungen/',
          pl: '/warunkikorzystania/',
          at: '/nutzungsbedingungen/',
          en: '/terms/'
        }
      }), /*#__PURE__*/_jsx(Route, {
        id: 'lpPrivacy',
        path: {
          de: '/datenschutz/',
          pl: '/politykaprywatnosci/',
          at: '/datenschutz/',
          en: '/privacy/'
        }
      }), /*#__PURE__*/_jsx(Route, {
        staticPath: true,
        id: 'pcmatchinghome',
        path: {
          de: '/arbeitnehmer/app/home/',
          pl: '/pracownik/app/home/',
          at: '/arbeitnehmer/app/home/',
          en: '/employee/app/home/'
        }
      }), /*#__PURE__*/_jsx(Route, {
        staticPath: true,
        id: 'pcmatchinglikedirect',
        path: {
          de: '/arbeitnehmer/app/like/',
          pl: '/pracownik/app/like/',
          at: '/arbeitnehmer/app/like/',
          en: '/employee/app/like/'
        }
      }), /*#__PURE__*/_jsx(Route, {
        staticPath: true,
        id: 'pcmigrate',
        path: {
          de: '/arbeitnehmer/app/migrate/',
          pl: '/pracownik/app/migrate/',
          at: '/arbeitnehmer/app/migrate/',
          en: '/employee/app/migrate/'
        }
      }), /*#__PURE__*/_jsx(Route, {
        staticPath: true,
        id: 'bcsetpassword',
        path: {
          de: '/arbeitgeber/app/set-password/',
          pl: '/pracodawca/app/set-password/',
          at: '/arbeitgeber/app/set-password/',
          en: '/employer/app/set-password/'
        }
      }), /*#__PURE__*/_jsx(Route, {
        staticPath: true,
        id: 'pcregistration',
        path: {
          de: '/fahrer/jobsuche/registrierung/',
          at: '/fahrer/jobsuche/registrierung/',
          pl: '/kierowca/szukaj-pracy/rejestracja/'
        }
      })]
    })
  });
};
var App = function App(_ref3) {
  var router = _ref3.router,
    location = _ref3.location,
    sessionResource = _ref3.sessionResource;
  var notistackRef = /*#__PURE__*/React.createRef();
  var onClickDismiss = function onClickDismiss(key) {
    return function () {
      notistackRef.current.closeSnackbar(key);
    };
  };
  return /*#__PURE__*/_jsx(Suspense, {
    fallback: '',
    children: /*#__PURE__*/_jsx(AuthProvider, {
      sessionResource: sessionResource,
      cookieStore: typeof document !== 'undefined' ? document.cookie : '',
      children: /*#__PURE__*/_jsx(SnackbarProvider, {
        maxSnack: 5,
        ref: notistackRef,
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'right'
        },
        action: function action(key) {
          return /*#__PURE__*/_jsx(IconButton, {
            "aria-label": "Close",
            color: "inherit",
            onClick: onClickDismiss(key),
            children: /*#__PURE__*/_jsx(CloseIcon, {
              color: "white"
            })
          }, "close");
        },
        children: /*#__PURE__*/_jsx(TrackingProvider, {
          children: /*#__PURE__*/_jsx(RoutedApp, {
            router: router,
            location: location
          })
        })
      })
    })
  });
};
export default /*#__PURE__*/React.memo(App);